export const MINUS_ONE = -1;
export const FORGOT_PASSWORD_PAGE = '/forgotPassword';
export const RESET_PASSWORD_PAGE = '/resetPassword';
export const LOGIN_PAGE = '/';
export const PASSWORD_RESET_SUCCESS = 'passwordResetSuccess';
export const RESET_PASSWORD_EMAIL = 'resetPasswordEmail';
